import React from "react";

import { Alert } from "./Alert";

const AlertContainer = ({ alerts, onAlertClose }) => {
	const handleOnAlertClose = (index) => {
		const alertsCopy = Array.from(alerts);
		alertsCopy.splice(index, 1);
		onAlertClose(alertsCopy);
	};

	return (
		<div className="alert-container">
			{alerts.filter(Boolean)?.map((alert, index) => (
				<Alert
					key={index}
					index={index}
					onAlertClose={handleOnAlertClose}
					{...alert}
				/>
			))}
		</div>
	);
};

export default AlertContainer;
